import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Menu } from "./components/core/Menu/menu";
import { logout } from "./app/userSlice";
import { Mask } from "./components";
import { setAccessError, setError } from "./app/appSlice";
import { selectIsLoading } from "./app/uiSlice";
import { BrowserRouter } from "react-router-dom";
import RenderRoutes from "./renderRoutes";

export const App = ({ RouterComponent = BrowserRouter }) => {
  const dispatch = useDispatch();
  const loading = useSelector(selectIsLoading);
  const user = useSelector((state) => state.user);

  const doLogout = (e) => {
    e.preventDefault();
    dispatch(setError(""));
    dispatch(setAccessError(null));
    dispatch(logout());
  };

  return (
    <RouterComponent
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <div className="App" data-testid="app" style={{ backgroundColor: "#dadee0" }}>
        <RenderRoutes nav={() => <Menu logout={doLogout} user={user} />} />
        {loading && <Mask />}
      </div>
    </RouterComponent>
  );
};
